import { render, staticRenderFns } from "./DocumentParts.vue?vue&type=template&id=b15ab9ea&scoped=true"
import script from "./DocumentParts.vue?vue&type=script&lang=js"
export * from "./DocumentParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15ab9ea",
  null
  
)

export default component.exports